import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store} from "./screens/store/store";
import {Provider} from "react-redux";

// CRA's dev overlay treats this benign browser warning as a fatal runtime error.
// Capture phase runs before the overlay's bubble listener (registered by the dev client).
const BENIGN_RESIZE_OBSERVER_ERRORS = new Set([
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop completed with undelivered notifications",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop limit exceeded.",
]);

window.addEventListener(
    "error",
    (event) => {
        if (BENIGN_RESIZE_OBSERVER_ERRORS.has(event.message)) {
            event.stopImmediatePropagation();
        }
    },
    true,
);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");
const root = ReactDOM.createRoot(rootEl);
root.render(
    <Provider store={store}>
        <App/>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
